import { useSelector } from "react-redux";

export const Loader = ({isLoading}) =>{
    if(isLoading) {
        return (
            <div style={style.view}>
                <img src={'/images/loader.gif'} style={{height:100,width:100}} />
            </div>
        )
    } else {
        return null;
    }
}

const style = {
    view:{
        position:'absolute',
        zIndex:99,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        height:'100%',
        width:'100%',
        backgroundColor:'rgba(0,0,0,0.7)'
    },
}